<script>
export default
{
    name: 'mv-pager',

    props:
    {
        data: {
            type: Object,
            default: () => {}
        },
    },

    computed:
    {
        hasPrevious()
        {
            return this.data.current_page > 1 && this.data.last_page > 1
        },

        hasNext()
        {
            return this.data.current_page < this.data.last_page
        },

        pages()
        {
            const arr = []
            for (let i = 0; i < this.data.last_page; ++i)
            {
                arr.push(i + 1)
            }
            const first = this.data.current_page < 5 ? 0 : this.data.current_page - 5
            return arr.slice(first, this.data.current_page + 5)
        }

    },

    methods:
    {
        toPage(page)
        {
            this.$emit('page', page)
        }
    }
}
</script>

<template>
<nav aria-label="Pager" v-if="data.last_page > 1">
    <ul class="pagination justify-content-center">
        <li class="page-item"><a 
                        class="page-link"
                        href="#"
                        @click.prevent.stop="toPage(1)"
                        v-show="hasPrevious"
                        v-html="$t('GENERAL.FIRST_PAGE')"></a></li>
        <li class="page-item"><a 
                        class="page-link" 
                        href="#"
                        @click.prevent.stop="toPage(data.current_page - 1)"
                        v-show="hasPrevious"
                        v-html="$t('GENERAL.PREVIOUS_PAGE')"></a></li>
        <li 
            class="page-item" 
            :class="{ 'active': page === data.current_page }" 
            v-for="page in pages" 
            :key="page"
            >
            <a class="page-link" href="#" @click.prevent.stop="toPage(page)">{{ page }}</a>
        </li>
        <li class="page-item"><a 
                        class="page-link"
                        href="#"
                        @click.prevent.stop="toPage(data.current_page + 1)"
                        v-show="hasNext" v-html="$t('GENERAL.NEXT_PAGE')"></a></li>
        <li class="page-item"><a 
                        class="page-link"
                        href="#"
                        @click.prevent.stop="toPage(data.last_page)"
                        v-show="hasNext"
                        v-html="$t('GENERAL.LAST_PAGE')"></a></li>
    </ul>
</nav>
</template>


// WEBPACK FOOTER //
// src/components/Pager.vue